import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import DatePicker from 'component/utils/DatePicker'
import Select from 'component/utils/Select'
import CompanySelect from 'component/branch/CompanySelect'

class SuggestionFilterForm extends Component {
  handleSubmit = (event) => {
    event.preventDefault()

    const { values, handleFilters } = this.props

    handleFilters(values)
  }

  clearFields = () => {
    const { fields, setValueToField } = this.props

    Object.keys(fields).forEach((field) => {
      setValueToField(field, '')
    })
  }

  render() {
    const { translate, fields, setValueToField } = this.props

    return (
      <form className='MenuSuggestionFilterForm'>
        <fieldset>
          <Row>
            <Col xs={12}>
              <legend>{translate('suggestions.filter-suggestions')}</legend>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.idBranch}
                error={translate(fields.idBranch.error)}
              >
                <CompanySelect {...fields.idBranch.input} />
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.cdStatus}
                error={translate(fields.cdStatus.error)}
              >
                <Select id='cdStatus' label='Status' {...fields.cdStatus.input}>
                  <option value='' />
                  <option value='0'>
                    {translate('suggestion.status.pending')}
                  </option>
                  <option value='1'>
                    {translate('suggestion.status.answered')}
                  </option>
                </Select>
              </Field>
            </Col>
          </Row>

          <Row>
            <Col xs={6} md={6}>
              <div className='field'>
                <Field
                  {...fields.dtStart}
                  error={translate(fields.dtStart.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    {...fields.dtStart.input}
                    placeholder={translate('suggestion.startDate')}
                    isOutsideRange
                    onDateChange={(date) => setValueToField('dtStart', date)}
                  />
                </Field>
              </div>
            </Col>
            <Col xs={6} md={6}>
              <div className='field'>
                <Field
                  {...fields.dtEnd}
                  error={translate(fields.dtEnd.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    {...fields.dtEnd.input}
                    placeholder={translate('suggestion.endDate')}
                    isOutsideRange
                    onDateChange={(date) => setValueToField('dtEnd', date)}
                  />
                </Field>
              </div>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={6} md={6}>
            <button
              role='button'
              type='button'
              onClick={this.clearFields}
              className='button-hollow button-hollow-danger button-full align-center'
            >
              {translate('cancel_button_label')}
            </button>
          </Col>

          <Col xs={6} md={6}>
            <button
              role='button'
              type='button'
              onClick={this.handleSubmit}
              className='button button-primary button-full'
            >
              {translate('filter_button_label')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

SuggestionFilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleFilters: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
}

const fields = ['idBranch', 'cdStatus', 'dtStart', 'dtEnd']

export default Form({ fields })(SuggestionFilterForm)

export { SuggestionFilterForm }
